import { useLocation } from "wouter";
import { useTranslation } from "react-i18next";
import MyContainer from "@/components/MyContainer";
import { LinkButton } from "@/components/ui/buttons/link-button";
import CustomerAsyncTable from "./components/customer-async-data-table";
import { routes } from "@/routes/route-constants";

export default function CustomerPage() {
  const { t } = useTranslation('customer');
  const [, navigate] = useLocation();

  return (
    <MyContainer
      title={t('title')}
      subtitle={t('manageSubtitle')}
      enableBack={false}
      actions={
        <>
          <LinkButton
            label={t('addNew')}
            onClick={() => navigate(routes.customer.new())}
          />
        </>
      }
    >
      <CustomerAsyncTable />
    </MyContainer>
  );
}
